// extracted by mini-css-extract-plugin
export default {"warningBanner":"styles_warningBanner__eo44q","title":"styles_title__mOnla","subtitle":"styles_subtitle__exsqU"};